import { FC } from "react";
import { ThemeProvider } from "styled-components";

const theme = {};

const Theme: FC<any> = ({ children }) => (
  <ThemeProvider theme={theme}>{children}</ThemeProvider>
);

export default Theme;
